export default {
  order_methods: {
    delivery: 'Livrare',
    pickup: 'Ridicare',
    room_service: 'La restaurant',
    table_service: 'La restaurant',
  },
  time: '{{time}} min',
  asap: 'ASAP',
  unavailable: 'Indisponibil',
  ready_in: 'Gata în ',
  buttons: {
    change: 'Schimbă',
    see_hours: 'Vezi orarul',
    change_location: 'Schimbă locația',
    change_time: 'Schimbă ora',
  },
};
